// components/SignUpFlow.jsx
import React, { useState } from 'react';
import AccountTypeSelector from './AccountType';
import RegisterPage from './RegisterPage';

const SignUpFlow = () => {
  const [accountType, setAccountType] = useState(null);

  return (
    <>
      {!accountType ? (
        <AccountTypeSelector onNext={(type) => setAccountType(type)} />
      ) : (
        <RegisterPage accountType={accountType} />
      )}
    </>
  );
};

export default SignUpFlow;
